<template>
  <header>
    <div class="header">
      <router-link :to="{name: 'Home'}" class="header-logo"></router-link>

      <header-buttons/>

    </div>
  </header>
</template>

<script>
import HeaderButtons from "@/components/HeaderButtons";
export default {
  name: "MainHeader",
  components: {HeaderButtons},
}
</script>

<style scoped lang="scss">
header {
  z-index: 1002;
}
.header {
  max-width: 1280px;
  width: 80px;
  display: flex;
  justify-content: flex-start;
  background: var(--common-background-shape);
  border-radius: 20px;
  height: 610px;
  flex-direction: column;
  box-shadow: var(--common-content-box-shadow);
  position: fixed;
  left: 60px;
  top: 40px;


  &-logo {
    border-bottom: 1px solid var(--common-text);
    background-image: url(/static-frontend/svg/logo.svg);
    background-size: 64%;
    background-position: center;
    background-repeat: no-repeat;
    width: 50%;
    margin: 0 auto;
    height: 70px;
    padding: 2rem 1.5rem;
  }

  a {
    cursor: pointer;

    span {
      font-size: 1.5em;
      color: var(--common-text);
    }
  }

}

@media (max-width: 1200px) {
  .header {
    left: 30px;
    top: 20px
  }
}
</style>
